<script lang="typescript">
    import Loader from "shared/loader.svelte";
    import Form from "shared/form.svelte";
    import Switch from "shared/switch.svelte";
    import Input from "shared/input.svelte";
    import InputTextArea from "shared/input-textarea.svelte";
    import { RequiredValidation } from "shared/validations/required";
    import { RegexValidation } from "shared/validations/regex";
    import Button from "shared/button.svelte";

    import Sheet from "shared/sheet.svelte";
    import Header from "../components/header.svelte";
    import SectionHeader from "../components/section-header.svelte";
    import SectionSubHeader from "../components/section-subheader.svelte";
    import Subtitle2 from "shared/typography/subtitle2.svelte";
    import {
        MailIcon,
        NotificationIcon,
        WhatsappIcon,
    } from "../components/icons";
    import { onMount } from "svelte";
    import { to } from "../utils";
    import * as ApiService from "../services/api.service";

    let redirectEmail = false;
    let redirectWhatsapp = false;
    let isFormValid = true;
    let isFormProcessing = true;
    let status = "";

    //TODO: remove on production
    let config: IConfig = {
        queries: {
            input: "./queries/input.sql",
            journey: "./queries/journey.sql",
        },

        extractor: {
            type: "MSSQL",
            connection: "",
        },

        notifications: {
            email: {
                smtp: "",
                account: "",
                secret: "",
                redirectEmail: false,
                redirectEmailAddress: "",
                mailCopy: "",
            },

            whatsapp: {
                service: "",
                company: "",
                line: "",
                token: "",
                redirectWhatsapp: false,
                redirectWhatsappLines: "",
            },

            desktop: {
                domain: "",
                account: "",
                token: "",
            },
        },
    };

    const sleep = (n: number) =>
        new Promise((resolve, reject) => setTimeout(resolve, n));

    const onSave = async () => {
        status = "Salvando configurações...";
        isFormProcessing = true;

        let [error, ok] = await to(ApiService.saveConfig(config));

        if (error) {
            status = "Error ao salvar configuração...";
        }
        await sleep(2000);
        isFormProcessing = false;
    };
    const onInpupt = (e) => {
        console.log(e);
    };

    const refreshConfig = async () => {
        isFormProcessing = true;
        let [error, newConfig] = await to(ApiService.getConfig());

        if (error) {
            status = "Não foi possível obter as configurações";
            return;
        }

        config = newConfig;
        status = "";
        isFormProcessing = false;
    };

    onMount(() => {
        refreshConfig();
    });
</script>

<div class="config-view">
    <Form bind:isValid={isFormValid}>
        <div class="content">
            <Header
                title="Configurações"
                subtitle="Configure todos os aspectos do serviço time-checker"
            />

            <!-- Buttons -->
            <div class="buttons">
                {#if isFormProcessing}
                    <div class="status">
                        <Loader size={36} />
                        <Subtitle2 text={status} style="padding: 0 16px;" />
                    </div>
                {/if}
                <Button
                    disabled={!isFormValid || isFormProcessing}
                    text="salvar"
                    type="rised"
                    on:click={onSave}
                />
            </div>

            <SectionHeader
                icon={NotificationIcon}
                title="Extrator"
                subtitle="Configure de qual fonte de dados serão coletadas as informações"
            />

            <div class="section">
                <Sheet style="padding: 16px;">
                    <div class="row row-2">
                        <Input
                            id="extractor.type"
                            name="extractor.type"
                            label="Tipo de Banco de Dados"
                            placeholder="Conta usada para se autenticar"
                            bind:value={config.extractor.type}
                            disabled={true}
                        />

                        <Input
                            id="extractor.connection"
                            name="extractor.connection"
                            label="String de Conexão"
                            type="text"
                            placeholder="String de conexão usada"
                            bind:value={config.extractor.connection}
                            validations={[
                                RequiredValidation(
                                    "Este campo não pode ficar em branco"
                                ),
                            ]}
                        />
                    </div>
                </Sheet>
            </div>

            <SectionHeader
                icon={NotificationIcon}
                title="Notificacões"
                subtitle="Configure como as notificações vão se comportar"
                
            />

            <!-- Mail-->
            <SectionSubHeader icon={MailIcon} title="Notificações por E-Mail" color="var(--color-info)" />
            <div class="section">
                <Sheet style="padding: 16px;">
                    <div class="row row-2">
                        <Input
                            id="notifications.email.smtp"
                            name="notifications.email.smtp"
                            label="Servidor SMTP"
                            placeholder="Servidor de envio"
                            bind:value={config.notifications.email.smtp}
                            validations={[
                                RequiredValidation(
                                    "Este campo não pode ficar em branco"
                                ),
                            ]}
                        />
                    </div>

                    <div class="row row-2">
                        <Input
                            id="notifications.email.account"
                            name="notifications.email.account"
                            label="Conta de envio"
                            placeholder="Conta usada para se autenticar"
                            bind:value={config.notifications.email.account}
                            validations={[
                                RequiredValidation(
                                    "Este campo não pode ficar em branco"
                                ),
                            ]}
                        />

                        <Input
                            id="notifications.email.secret"
                            name="notifications.email.secret"
                            label="Senha"
                            type="password"
                            placeholder="Senha usada para se autenticar"
                            bind:value={config.notifications.email.secret}
                            validations={[
                                RequiredValidation(
                                    "Este campo não pode ficar em branco"
                                ),
                            ]}
                        />
                    </div>

                    <div class="row row-1">
                        <Input
                            id="notifications.mailCopy"
                            name="notifications.mailCopy"
                            label="Copiar as notificações"
                            placeholder="Copiar todos os envios para"
                            bind:value={config.notifications.email.mailCopy}
                            validations={[
                                RegexValidation(
                                    /^$|^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4},?)+$/i,
                                    "E-mails separados por ',' "
                                ),
                            ]}
                        />
                    </div>

                    <div class="row row-2">
                        <Subtitle2
                            text="Redirecionar todas as notificações para outro endereço?"
                        />
                        <Switch
                            bind:value={config.notifications.email
                                .redirectEmail}
                        />
                    </div>
                    <div class="row row-1">
                        <Input
                            id="notifications.redirectEmailAddress"
                            name="notifications.redirectEmailAddress"
                            label="Redirecionar"
                            disabled={!config.notifications.email.redirectEmail}
                            placeholder="Redirecionar todos os e-mails para"
                            bind:value={config.notifications.email
                                .redirectEmailAddress}
                            validations={[
                                RegexValidation(
                                    /^$|^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4},?)+$/i,
                                    "E-mails separados por ',' "
                                ),
                            ]}
                        />
                    </div>
                </Sheet>
            </div>

            <!-- WhatsApp -->
            <SectionSubHeader icon={WhatsappIcon} title="Whatsapp" color="var(--color-success)" />
            <div class="section">
                <Sheet style="padding: 16px;">
                    <div class="row row-2">
                        <Input
                            id="config.notifications.whatsapp.service"
                            name="config.notifications.whatsapp.service"
                            label="Endereço do Serviço"
                            bind:value={config.notifications.whatsapp.service}
                            placeholder="Http://..."
                            validations={[
                                RequiredValidation(
                                    "Este campo não pode ficar em branco"
                                ),
                            ]}
                        />
                        <Input
                            id={config.notifications.whatsapp.line}
                            name="config.notifications.whatsapp.line"
                            bind:value={config.notifications.whatsapp.line}
                            label="Número da linha telefônica"
                            placeholder="Linha telefonica do cadastro do serviço"
                            validations={[
                                RequiredValidation(
                                    "Este campo não pode ficar em branco"
                                ),
                            ]}
                        />
                    </div>
                    <div class="row">
                        <Input
                            id="config.notifications.whatsapp.company"
                            name="config.notifications.whatsapp.company"
                            bind:value={config.notifications.whatsapp.company}
                            label="Id de Empresa"
                            placeholder="Indicar o ID da Empresa do cadastro do serviço"
                            validations={[
                                RequiredValidation(
                                    "Este campo não pode ficar em branco"
                                ),
                            ]}
                        />
                        <Input
                            id="config.notifications.whatsapp.token"
                            name="config.notifications.whatsapp.token"
                            bind:value={config.notifications.whatsapp.token}
                            label="Token de Serviço"
                            type="password"
                            placeholder="Service secret used to autneticate"
                            validations={[
                                RequiredValidation(
                                    "Este campo não pode ficar em branco"
                                ),
                            ]}
                        />
                    </div>

                    <div class="row">
                        <Subtitle2 text="Redirecionar todas as notificações?" />
                        <Switch
                            bind:value={config.notifications.whatsapp
                                .redirectWhatsapp}
                        />
                    </div>
                    <div class="row row-1">
                        <Input
                            id="config.notifications.whatsapp.redirectWhatsappLines"
                            name="config.notifications.whatsapp.redirectWhatsappLines"
                            bind:value={config.notifications.whatsapp
                                .redirectWhatsappLines}
                            label="Linhas de redirecionamento"
                            type="text"
                            placeholder="Linhas para redirecionamento"
                            validations={[
                                RegexValidation(
                                    /^$|^([0-9]{12},?)+$/i,
                                    "Telefones separados por ',' "
                                ),
                            ]}
                        />
                    </div>
                </Sheet>
            </div>
        </div>
    </Form>
</div>

<style>
    .config-view {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        /* padding: 0 10%; */
        align-items: center;
        overflow: auto;
    }
    .content {
        display: flex;
        flex-direction: column;
        min-width: 800px;
        height: 100%;
        max-width: 1200px;
    }
    .row {
        grid-template-columns: auto 1fr;
        display: grid;
        column-gap: 16px;
        margin-bottom: 8px;
    }

    .row-1 {
        grid-template-columns: auto;
    }
    .row-2 {
        grid-template-columns: 1fr 1fr;
    }
    

    .section {
        padding-bottom: 32px;
    }

    /* TODO: tranform this in a component */
    .buttons {
        height: 48px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin: 16px 0;
    }

    .status {
        display: flex;
        flex-direction: row;
        margin-right: 32px;
        align-items: center;
        /* justify-content: center; */
        width: 100%;
    }
</style>
